module.exports = __webpack_public_path__ + "static/media/1004909.f843e738.png";